module.exports = __webpack_public_path__ + "img/tp5.98040ebe.png";